import { ConsentUpdate, Purpose } from '@mfec/types/model';

// transform for POST ConsentUpdateList
// but only not granted consents should be saved
export const transformConsents4Save = (actualConsents: Purpose[]): ConsentUpdate[] => actualConsents
  .flatMap((purpose) => purpose.subscriptions
    .flatMap((subscription) => subscription.apps
      .filter((app) => !app.granted).map((app) => ({
        id: app.consentId,
        status: 'revoked',
      }))));

//
// Transforms the structure returned by getConsents4mfe to the structure expected by postConsentsUpdateList
//
export const transformGetConsents4mfeToPostConsentUpdateList = (actualConsents: Purpose[]): ConsentUpdate[] => actualConsents
  .flatMap((purpose) => purpose.subscriptions.flatMap((subscription) => subscription.apps
    .map((app) => ({
      id: app.consentId,
      status: app.granted ? 'active' : 'revoked',
    }))));
